// extracted by mini-css-extract-plugin
module.exports = {"head":"ConstructionControlObject_head__fHzmS","outerTemplate":"ConstructionControlObject_outerTemplate__2LNAt"};